import { useEffect } from 'react';
import ReactGA from 'react-ga4';

/**
 * @param {GoogleAnalyticsOptions} options
 */
export function useGoogleAnalytics(_ref) {
  let {
    measurementId,
    location,
    options
  } = _ref;
  useEffect(() => {
    if (ReactGA.isInitialized) return;
    ReactGA.initialize(measurementId, options);
  }, [measurementId, options]);
  const page = location.pathname + location.search;
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page
    });
  }, [page]);
}

/**
 * @typedef {object} GoogleAnalyticsOptions
 * @prop {string} measurementId
 * @prop {Location} location
 * @prop {ReactGAInitializeOptions} [options]
 */

/**
 * @typedef {NonNullable<Parameters<typeof ReactGA['initialize']>[1]>} ReactGAInitializeOptions
 */